import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import IndexM from "./IndexM";
import BetSlip from "./BetSlip";
import ParTrans from "./ParTrans";
import LiveCenterWithOdds from "./LiveCenterWithOdds";
import LiveTVGLS from "./LiveTVGLS";
import LiveTVMV from "./LiveTVMV";
import "./i18nextConf";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<IndexM />} />
      <Route path="/BetSlip" element={<BetSlip />} />
      <Route path="/ParTrans" element={<ParTrans />} />
      <Route path="/LiveCenterWithOdds" element={<LiveCenterWithOdds />} />
      <Route path="/LiveTVGLS" element={<LiveTVGLS />} />
      <Route path="/LiveTVMV" element={<LiveTVMV />} />
    </Routes>
  </BrowserRouter>
);
